"use strict";

var _frameworkImportPath = require("@storybook/preact");

/* eslint-disable import/no-unresolved */
(0, _frameworkImportPath.configure)([require.context('../stories', true, /^\.(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?stories\.js)$/),require.context('../plugins', true, /^\.(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?stories\.js)$/),require.context('containers', true, /^\.(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?stories\.js)$/)], module, false);